module.exports = __webpack_public_path__ + "static/media/6.11_preview.aa82dfdc.png";